import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Tooltip } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { palette } from '../../../../../../../settings/themes/colors';

const useStyles = makeStyles({
  infoIcon: {
    fontSize: 16,
    color: palette.dimGray,
    cursor: 'pointer'
  }
});

const isEmpty = value => value == null || (typeof value === 'string' && value.trim() === '');

export const DashboardHelpIcon = ({ text }) => {
  const classes = useStyles();

  if (isEmpty(text)) return null;

  const title = typeof text === 'string' ? <span style={{ whiteSpace: 'pre-line' }}>{text}</span> : text;

  return (
    <Tooltip title={title} arrow enterTouchDelay={0} leaveTouchDelay={3000}>
      <InfoOutlinedIcon data-testid="help-icon" className={classes.infoIcon} />
    </Tooltip>
  );
};

DashboardHelpIcon.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
};

DashboardHelpIcon.defaultProps = {
  text: null
};
